import React, { useState, useEffect, useMemo } from 'react';
import styles from './styles/packages.module.css';
import checkIcon from '../../assets/images/checkCircleIcon.png';
import useMediaQuery from '../../hooks/useMediaQuery';
import logo from '../../assets/images/DtpLogoSmall.webp';
import { CheckoutService } from '../../services/CheckoutService';

const Packages = () => {
    const trial = 0;

    const [packagePrices, setPackagePrices] = useState();

    const basicPackage = useMemo(() => packagePrices?.filter((item) => item.nickname === "Basic Plan")[0], [packagePrices]);
    const familyPackage = useMemo(() => packagePrices?.filter((item) => item.nickname === "Family Plan")[0], [packagePrices]);
    const unlimitedPackage = useMemo(() => packagePrices?.filter((item) => item.nickname === "Unlimited Plan")[0], [packagePrices]);

    const isAboveMediumScreens = useMediaQuery("(min-width: 801px)");

    useEffect(() => {
        const onInit = async () => {
            const data = await CheckoutService.getPackage(process.env.REACT_APP_PUBLIC_STRIPE_THREE_PRODUCT_ID);
            let prices = data.prices;
            setPackagePrices(prices);
        }
        onInit();
    }, []);



    return (
        <div className={styles.mainContainer}>
            <nav className={styles.navMainContainer}>
                <div className={styles.maxWidth}>
                    <a href="/"><img src={logo} alt="logo" className={styles.logo} /></a>
                </div>
            </nav>
            <h2 className={styles.packageHeader}>Choose Your Plan</h2>
            <h4>All plans include:</h4>
            <div className={styles.featureContainer}>
                <ul className={styles.featureList}>
                    <li className={styles.listItem}>
                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Effortless Live Tracking</p>
                    </li>
                    <li className={styles.listItem}>
                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Full 30-Day Loaction History</p>
                    </li>
                    <li className={styles.listItem}>
                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>IOS and Android Compatible</p>
                    </li>
                    <li className={styles.listItem}>
                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Works On Any Network</p>
                    </li>
                    <li className={styles.listItem}>
                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Free To Cancel Anytime</p>
                    </li>
                </ul>
            </div>
            <div className={styles.packageContainer}>

                {basicPackage &&
                    <div className={styles.package} onClick={!isAboveMediumScreens ? () => CheckoutService.initStripeSession('', trial, basicPackage.id) : null}>
                        <p className={styles.packageName}>{basicPackage.nickname}</p>
                        <div className={styles.packagePrice}>{basicPackage.label}<span className={styles.pricePeriod}>/month</span></div>
                        <p className={styles.deviceLimit}>Track 2 devices</p>
                        <p className={styles.packageFeature}>Ideal for families and close friends</p>
                        {isAboveMediumScreens && <button className={styles.selectPlanButton} onClick={() => CheckoutService.initStripeSession('', trial, basicPackage.id)}>Select Plan</button>}
                    </div>
                }
                {familyPackage &&

                    <div className={styles.recomendedPackageContainer} onClick={!isAboveMediumScreens ? () => CheckoutService.initStripeSession('', trial, familyPackage.id) : null}>
                        <p className={styles.recomendedTitle}>Recomended for you</p>
                        <div className={styles.recomendedPackage}>
                            <p className={styles.packageName}>{familyPackage.nickname}</p>
                            <div className={styles.packagePrice}>{familyPackage.label}<span className={styles.pricePeriod}>/month</span></div>
                            <p className={styles.deviceLimit}>Track 5 devices</p>
                            <p className={styles.packageFeature}>Ideal for couples and individuals</p>
                            {isAboveMediumScreens && <button className={styles.selectPlanButton} onClick={() => CheckoutService.initStripeSession('', trial, familyPackage.id)}>Select Plan</button>}
                        </div>
                    </div>
                }
                {unlimitedPackage && <div className={styles.package} onClick={!isAboveMediumScreens ? () => CheckoutService.initStripeSession('', trial, unlimitedPackage.id) : null}>
                    <p className={styles.packageName}>{unlimitedPackage.nickname}</p>
                    <div className={styles.packagePrice}>{unlimitedPackage.label}<span className={styles.pricePeriod}>/month</span></div>
                    <p className={styles.deviceLimit}>Track unlimited devices</p>
                    <p className={styles.packageFeature}>Ideal for travellers and large groups</p>
                    {isAboveMediumScreens && <button className={styles.selectPlanButton} onClick={() => CheckoutService.initStripeSession('', trial, unlimitedPackage.id)}>Select Plan</button>}
                </div>}
            </div>
        </div >
    )
}

export default Packages